import {Component, ElementRef, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fullscreen',
  encapsulation: ViewEncapsulation.None,
  template: `
    <button mat-icon-button class="full-screen">
        <mat-icon *ngIf="!toggle" #expand>fullscreen</mat-icon>
        <mat-icon *ngIf="toggle" #compress>fullscreen_exit</mat-icon>
    </button> 
  `
})
export class FullScreenComponent { 
    toggle:boolean = false;
    @ViewChild('expand') private expand:ElementRef;
    @ViewChild('compress') private compress:ElementRef; 
   
    requestFullscreen(elem) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        } else {
            console.log('Fullscreen API is not supported.');
        }
    };

    exitFullscreen() {
        if ((<any>document).exitFullscreen) {
            (<any>document).exitFullscreen();
        } else if ((<any>document).webkitExitFullscreen) {
            (<any>document).webkitExitFullscreen();
        } else if ((<any>document).mozCancelFullScreen) {
            (<any>document).mozCancelFullScreen();
        } else if ((<any>document).msExitFullscreen) {
            (<any>document).msExitFullscreen();
        } else {
            console.log('Fullscreen API is not supported.');
        }
    };

    @HostListener('click') getFullscreen(){
        if(this.expand){
            this.requestFullscreen((<any>document).documentElement);
        }
        if(this.compress){
            this.exitFullscreen();
        }
    }

    @HostListener('window:resize') onFullScreenChange(){
        let fullscreenElement = (<any>document).fullscreenElement || (<any>document).mozFullScreenElement ||
                                (<any>document).webkitFullscreenElement || (<any>document).msFullscreenElement;
        if (fullscreenElement != null) {
            this.toggle = true;
        } else {
            this.toggle = false;          
        }
    }   

}